<template>
    <div class="main-container">
        <div class="login-wrapper">
            <img :src="logo" alt="Wingio Logo" class="mb-3" height="80">
            <div class="login-card text-center">
                <div class="alert alert-danger small" role="alert" v-if="error">
                    {{ error }}
                </div>
                <h6 class="mb-1 text-left pl-4 small"><b>Recover your password!</b></h6>
                <form class="p-4">
                    <div class="form-group text-left mb-3">
                        <label for="email" class="form-label">Email</label>
                        <input type="email" id="email" v-model="email" class="form-control" placeholder="Email" required>
                    </div>
                    <div class="form-group text-center">
                        <button class="btn btn-primary w-100" :disabled="isDisabled" @click="sendForgetPasswordLink()">Send
                            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                        </button>
                    </div>
                    <div class="text-right mb-3 small">
                        Already have account? <a class="text-primary" href="javascript:void(0)" @click="$router.push('/login')"><b>Login</b></a>
                    </div>
                </form>
            </div>
        </div>
    </div>
        
    <!--<div class="main-container">
        <div style="margin-top:100px">
            <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="this.show_message">
                <strong>Congratulation!</strong> A message with a reset password link has been sent to your email address. Please open the link to set your new password.
            </div><br>
            <img :src="logo" class="img-fluid text-center" :style="{ 'width': '50%' }"	/><br><br>
        </div>
        <div :style="{ 'width': '100%' }">
            <form>
                <div class="form-group">
                    <input type="email" v-model="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email">
                </div>
                <div class="form-group text-center">
                    <button class="btn btn-primary login-btn" :disabled="isDisabled" @click="sendForgetPasswordLink()">Send
                        <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                    </button>
                </div>
            </form>
        </div>
        <div class="footer-menu-item text-center pb-4" :style=" { 'width': '90%' }">
          Already have account? <a class="forget-pass-link" href="javascript:void(0)" @click="$router.push('/login')"><b>Login</b></a>
        </div>
    </div>-->
</template>

<script>
import UserService from "../services/UserService";
export default {
  name: 'Login',
  props: {
    logo: {
        type: String,
        default: "./images/lya-logo.png",
    },
  },
  data() {
    return {
      isDisabled: false,
      email: null,
      show_message: false,
    };
  },
  methods: {
    async sendForgetPasswordLink() {
        this.isDisabled = true;
        let data = {
            email: this.email,
        };
        await UserService.sendForgetPasswordLink(data)
            .then((response) => {
                this.isDisabled = false;
                this.$toast.success(response.data.respones_msg);
                this.email = null;
                this.show_message = true;
            })
            .catch((e) => {
                this.isDisabled = false;
                this.$toast.error(e.response.data.respones_msg);
            });
    },
  },
  beforeMount() {
    
  },
}
</script>
<style scoped>
.login-wrapper {
  max-width: 400px;
  text-align: center;
}
.login-card {
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  background: #fff;
}
.recaptcha-text {
  font-size: 11px;
  color: #6c757d;
  margin-top: 1rem;
}
.password-input-wrapper {
  position: relative;
}

.password-input-wrapper input {
  padding-right: 2.5rem; /* space for the eye icon */
}

.toggle-eye {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d;
}

</style>